module.exports = __webpack_public_path__ + "download.png?2fdcfaab54fa40cd87768405a00fb3ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download.png
// module id = 654
// module chunks = 0 2 7 8 9 10 12